<template>
    <div>
        <div v-if="showProgressBar" class="bg-primary-5 rounded-32 overflow-hidden mb-16">
            <div :style="'width:'+ progress +'%;'" class="h-10 bg-primary rounded-32"></div>
        </div>

        <slot></slot>

        <div class="flex items-center mb-8">
            <svg-icon v-if="icon" class="text-secondary w-24 h-24 mr-12" :type="icon"></svg-icon>
            <h2 class="font-semibold text-heading-1 ">{{ title }}</h2>
        </div>

        <p v-html="description"></p>
    </div>
</template>

<script>
import SvgIcon from '../SvgIcon';
export default {
    name: 'PopupContent',
    components: {SvgIcon},
    props: {
        progress: {type: Number, default: 0},
        title: String,
        icon: {type: String, default: ''},
        description: String,
        showProgressBar: {type: Boolean, default: true},
    },
};
</script>